import { useMemo, useState } from "react";
import { CardCompanyDetails } from "./CardCompanyDetails";
import "../styles/result-card-grid.css";
import Button from "react-bootstrap/Button";

const ListCompanyInfoContainer = ({ children }) => {
  return (
    <div
      style={{
        borderLeft: "1px solid #e9ecef",
        paddingLeft: "24px",
        height: "100%",
      }}
    >
      <div>
        <i className="fa fa-briefcase mr-2" />
        Career History
      </div>
      <div className="mb-2" style={{ overflowY: "auto" }}>
        {children}
      </div>
    </div>
  );
};

export const ListCompanyInfo = ({ id, name, allMemberships }) => {
  const [expanded, setExpanded] = useState(false);

  // Get primary membership (current role or most recent)
  const currentMemberships = allMemberships?.filter((m) => !m.end_date) || [];
  const primaryMembership = currentMemberships[0] || allMemberships?.[0];

  // Get other memberships for modal
  const otherMemberships =
    allMemberships?.filter((m) => m !== primaryMembership) || [];

  // Group memberships by institution type
  const groupedMemberships = otherMemberships.reduce((acc, membership) => {
    const type = membership.institution_type || "Other";
    if (!acc[type]) acc[type] = [];
    acc[type].push(membership);
    return acc;
  }, {});

  // Sort memberships by start date (most recent first)
  Object.keys(groupedMemberships).forEach((type) => {
    groupedMemberships[type].sort(
      (a, b) => new Date(b.start_date) - new Date(a.start_date)
    );
  });

  const displayableMemberships = otherMemberships || [];

  // Group by year
  const groupedByYear = useMemo(
    () =>
      displayableMemberships.reduce((acc, role) => {
        const year = new Date(role.start_date).getFullYear();
        if (!acc[year]) acc[year] = [];
        acc[year].push(role);
        return acc;
      }, {}),
    [displayableMemberships]
  );

  if (!otherMemberships || otherMemberships.length === 0) {
    return (
      <ListCompanyInfoContainer>
        <p className="text-muted mt-2">No company info available.</p>
      </ListCompanyInfoContainer>
    );
  }

  const allRoles = Object.entries(groupedByYear)
    .sort(([a], [b]) => b - a)
    .flatMap(([year, roles]) => roles.map((role) => ({ ...role, year })));

  const visibleRoles = expanded ? allRoles : allRoles.slice(0, 1);

  return (
    <ListCompanyInfoContainer>
      <div className="mb-2" style={{ overflowY: "auto" }}>
        <ul className="list-unstyled ps-2">
          {visibleRoles.map((role, idx) => (
            <CardCompanyDetails
              key={role.id}
              role={role}
              idx={idx}
              dataLength={visibleRoles.length}
            />
          ))}
        </ul>
        <div className="d-flex justify-content-center">
          {allRoles.length > 2 && (
            <Button
              variant="link"
              className="p-0"
              onClick={() => setExpanded((prev) => !prev)}
            >
              {expanded ? "Show less" : `Show ${allRoles.length - 1} more`}
            </Button>
          )}
        </div>
      </div>
    </ListCompanyInfoContainer>
  );
};
